export default __webpack_public_path__ + "static/usage-step-1-909e0abf6612df0f93fa84eef06b6913.svg";